import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-weighed-product',
  templateUrl: './weighed-product.component.html',
  styleUrls: ['./weighed-product.component.scss'],
})
export class WeighedProductComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
